module.exports = __webpack_public_path__ + "img/discover.6338e455.svg";